import {
  OWNER_LOGIN_AS_ERROR_EXPIRED,
  OWNER_LOGIN_AS_ERROR_FORBIDDEN,
  OWNER_LOGIN_AS_ERROR_GENERIC,
  OWNER_LOGIN_AS_ERROR_INVALID,
  OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
  OWNER_LOGIN_AS_ERROR_UNAUTHORIZED,
  OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND,
} from "../i18n/keysTranslations";

const CREATE_ERROR_MESSAGE_KEYS = {
  missingParameters: OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
  advertiserNotFound: OWNER_LOGIN_AS_ERROR_USER_NOT_FOUND,
  forbidden: OWNER_LOGIN_AS_ERROR_FORBIDDEN,
  unauthorized: OWNER_LOGIN_AS_ERROR_UNAUTHORIZED,
};

const EXCHANGE_ERROR_MESSAGE_KEYS = {
  tokenExpired: OWNER_LOGIN_AS_ERROR_EXPIRED,
  tokenInvalid: OWNER_LOGIN_AS_ERROR_INVALID,
  missingParameters: OWNER_LOGIN_AS_ERROR_MISSING_PARAMS,
};

export const getOwnerLoginAsCreateErrorMessageKey = (code) =>
  CREATE_ERROR_MESSAGE_KEYS[code] || OWNER_LOGIN_AS_ERROR_GENERIC;

export const getOwnerLoginAsExchangeErrorMessageKey = (code) =>
  EXCHANGE_ERROR_MESSAGE_KEYS[code] || OWNER_LOGIN_AS_ERROR_GENERIC;
